exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DisablePopUp_ButtonDiv_3WgI2 {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}", ""]);

// Exports
exports.locals = {
	"ButtonDiv": "DisablePopUp_ButtonDiv_3WgI2"
};